import React, { useState } from 'react';
import { useTheme, makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import {
  FDBox, FDStack, FDTextButton,
} from '@facet-wealth/design';
import { localStorageMap } from 'Consts/localStorage';
import Header
  from 'Views/Page/Content/Templates/WhatIfProposalPreviewTemplate/MainContentPicker/MainContentForScenarioSelectionRedefined/Header';
import ResizableBox from 'Components/ComponentLibrary/Atoms/ResizableBox';
import Footer
  from 'Views/Page/Content/Templates/WhatIfProposalPreviewTemplate/MainContentPicker/MainContentDefault/RightSide/Footer';
import { IncludedRelationshipProvider } from 'Views/Page/Contexts/IncludedRelationshipContext';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import { ProposalScenarioPXForms } from 'Components/ComponentLibrary/Organisms/ProposalScenarioPXForms';
import ProposalInsightPicker
  from 'Views/Page/Content/Templates/WhatIfProposalPreviewTemplate/MainContentPicker/MainContentForScenarioSelectionRedefined/ProposalInsightPicker';
import ClientProposalView
  from 'Views/Page/Content/Templates/WhatIfProposalPreviewTemplate/MainContentPicker/MainContentForScenarioSelectionRedefined/ClientProposalView';
import { useSnackbarContext } from 'Context/SnackbarContext';

const useStyles = makeStyles((theme) => ({
  resizableBox: {
    width: theme.dimensions.md,
    borderRight: `1px solid ${theme.palette.facet.lightGray2}`,
    backgroundColor: theme.palette.common.white,
    height: '100%',
  },
  footer: {
    position: 'sticky',
    bottom: 0,
    width: '100%',
    zIndex: 1300,
  },
  deleteButton: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    '& > button': {
      color: theme.palette.facet.red,
    },
  },
}));

const MainContent = ({ resource, setPreviewCollection }) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { displayErrorMessage } = useSnackbarContext();

  const [unpublishing, setUnpublishing] = useState(false);
  const unpublish = async () => {
    try {
      setUnpublishing(true);
      const resp = await resource.delete();
      setUnpublishing(false);
      setPreviewCollection(resp);
    } catch (err) {
      setUnpublishing(false);
      displayErrorMessage(err, err.errors ?? 'Error unpublishing');
    }
  };

  return (
    <IncludedRelationshipProvider relationship={resource.relationship(fr.relationships.proposalPreviewDataForScenarioSelectionRedefined.name)}>
      <FDBox width={'100%'} height={'100%'}>
        <FDStack direction={'row'} width={'100%'} height={'100%'}>
          <ResizableBox
            className={classes.resizableBox}
            side={'right'}
            localStorageName={localStorageMap.scenarioLeftSideWidth}
            minSize={theme.dimensions.md}
          >
            <FDStack direction={'column'} spacing={3} paddingX={3} paddingY={2}>
              <Header />
              {resource.withRelationship(fr.relationships.proposalScenarioPX.name, (rel) => {
                return (
                  <ProposalScenarioPXForms relationshipLink={rel.link('related')} />
                );
              }, () => {
                return (<ProposalInsightPicker resource={resource} />);
              })}
              {resource.meta().canDelete() ? (
                <div className={classes.deleteButton}>
                  <FDTextButton onClick={unpublish} label="Unpublish" size="sm" loading={unpublishing} />
                </div>
              ) : null}
            </FDStack>
          </ResizableBox>
          <FDStack flexGrow={1} direction={'column'} alignItems={'center'} height={'100%'} width={'100%'}>
            <FDBox flexGrow={1} width={'100%'} paddingX={2}>
              <ClientProposalView />
            </FDBox>
          </FDStack>
        </FDStack>
        <Footer className={classes.footer} />
      </FDBox>
    </IncludedRelationshipProvider>
  );
};

MainContent.propTypes = {
  resource: PropTypes.object.isRequired,
  setPreviewCollection: PropTypes.func.isRequired,
};

export default MainContent;
